// 导入自己需要的组件
import { Radio,RadioGroup,RadioButton,DatePicker,Button,Popover,Calendar,Carousel,CarouselItem,Loading } from 'element-ui'
const element = {
    install: function (Vue) {

        Vue.use(Radio)
        Vue.use(RadioGroup)
        Vue.use(RadioButton)
        Vue.use(DatePicker)
        Vue.use(Button)
        Vue.use(Popover)
        Vue.use(Calendar)
        Vue.use(Carousel)
        Vue.use(CarouselItem)
        Vue.use(Loading)
    }
}
export default element
